var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPriceTag = function SvgPriceTag(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 12a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Zm20.43 7.07L22.07 6.44A1.5 1.5 0 0 0 21 6H7.5A1.5 1.5 0 0 0 6 7.5V21a1.5 1.5 0 0 0 .44 1.07l12.63 12.61a4.5 4.5 0 0 0 6.36 0l9.25-9.18a4.5 4.5 0 0 0 0-6.36v-.07Zm-2.11 4.23-9.27 9.25a1.5 1.5 0 0 1-2.12 0L9 20.4V9h11.39l12.18 12.18a1.5 1.5 0 0 1 0 2.12Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPriceTag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/priceTag.21bbb428faa28ccf921478313b85f771.svg";